import Vuex from 'vuex';

const state = {
    activeUrl: '',
    activeSection: '',
    isLoading: false, // indicates when e.g. infinite scroll is loading
    showMainMenu: false,
    showMobileNav: false,
    windowWidth: 0,
};


const mutations = {
    setActiveUrl(state, activeUrl) {
        state.activeUrl = activeUrl;
    },
    setNamespace(state, namespace) {
        let activeSection = namespace;
        let pageType = null;
        if (namespace.indexOf('|') > -1) {
            [activeSection, pageType] = namespace.split('|');
        }

        document.body.setAttribute('data-active-section', activeSection);
        document.body.setAttribute('data-page-type', pageType);

        // Overwrite openlab fragment entries sections, so the navigation is shown
        const sections = {
            'fragments': 'sonicWorld',
            'fragment': 'sonicWorld',
        };
        state.activeSection = Object.prototype.hasOwnProperty.call(sections, activeSection) ? sections[activeSection] : activeSection;
    },
    setLoading(state, isLoading) {
        state.isLoading = isLoading;
    },
    setShowMainMenu(state, showMainMenu) {
        state.showMainMenu = showMainMenu;
    },
    setShowMobileNav(state, showMobileNav) {
        state.showMobileNav = showMobileNav;
    },
    setWindowWidth(state, windowWidth) {
        state.windowWidth = windowWidth;
    },
};

const actions = {

};

const getters = {
    activePath (state) {
        // Take only path from full url
        let path = state.activeUrl.split(window.location.origin);
        path = path.length > 1 ? path[1].substr(1).replace(/\/+$/, '') : '';
        // Remove en/ prefix from path
        return path.startsWith('en/') ? path.substr(3) : path;
    },
};

const store = new Vuex.Store({
    state,
    mutations,
    actions,
    getters,
});

export default store;
